module.exports = {
  title: 'demo页面',
  route: {
    path: 'demo',
    children: {
      path: '',
    },
  },
};
